import styles from './style/layout.module.scss';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import { MdClose } from 'react-icons/md';
import Tabs from '../Utilities/Tabs';
import { selectMenu } from '../../store/slice/manager/menu';
import { getServiceName } from '../../constant/SERVICE_NAME_MAP';
import Admin from './Admin';
import PlanManagement from '../ExecutiveDashboard/PlanManagement';

// 服務管理列表的「編輯」modal：
// 上方共用標題 + 關閉，內容用分頁切「服務設定 / 方案管理」，兩者都在同一個 modal 內操作。
// 「企業帳號」(serviceId '0') 沒有方案，只顯示服務設定。
const ServiceEditModal = ({ serviceId, onClose }) => {
  const { detail, detailServiceId } = useSelector(selectMenu);
  const [tab, setTab] = useState(0);

  const isEnterprise = serviceId === '0';
  const tabs = ['服務設定', '方案管理'];
  // detail 為全域狀態，切換 service 時仍可能是前一個 service 的資料；
  // 確認相符才顯示服務名稱，否則先顯示通用標題，避免標題閃現前一個 service 的名稱。
  const detailReady = !!detail && String(detailServiceId) === String(serviceId);
  const title = isEnterprise ? '企業帳號' : detailReady ? getServiceName(detail?.name) : '服務設定';

  return (
    <div className={styles.serviceEditModal}>
      <div className={styles.modalHeader}>
        <div className={styles.modalTitle}>{title}</div>
        <div className={styles.closeBtn} onClick={onClose}>
          <MdClose />
        </div>
      </div>

      {!isEnterprise && (
        <div className={styles.modalTabs}>
          <Tabs values={tabs} selectedIndex={tab} onChange={(e) => setTab(e.tabIndex)} />
        </div>
      )}

      <div className={styles.modalTabBody}>
        {(isEnterprise || tab === 0) && <Admin serviceId={serviceId} isModal />}
        {!isEnterprise && tab === 1 && <PlanManagement serviceId={serviceId} isModal />}
      </div>
    </div>
  );
};

export default ServiceEditModal;
